const TZ = { timeZone: "Asia/Jakarta" };

// "Sen 26 Okt, 13.00" - untuk baris dan subline.
export const fmtShort = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      ...TZ, weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch { return "-"; }
};

// "Senin, 26 Oktober 2026, 13.00 WIB" - untuk rincian.
export const fmtLong = (iso) => {
  if (!iso) return "-";
  try {
    return `${new Date(iso).toLocaleString("id-ID", {
      ...TZ, weekday: "long", day: "numeric", month: "long", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    })} WIB`;
  } catch { return "-"; }
};

export const fmtQty = (n) => `${Number(n) || 0} pcs`;

export const CONDITION_LABELS = {
  BAIK: "Kondisi baik",
  RUSAK_RINGAN: "Rusak ringan",
  RUSAK_BERAT: "Rusak berat",
  HILANG: "Hilang",
};
export const fmtCondition = (c) => CONDITION_LABELS[c] || c || "-";
